var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-modal"},[_c('modal',{attrs:{"name":_vm.name,"width":_vm.width,"height":_vm.height,"clickToClose":_vm.clickToClose},on:{"before-open":_vm.beforeOpen,"before-close":_vm.beforeClose}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }